import React from 'react'
import PropTypes from 'prop-types'

import { VideoContainer } from './Video.styles'

const Video = React.forwardRef((props, ref) => {
    const { controls, onDurationChange, onLoadedMetadata, src, type,height,width } = props

    const formattedSrc = src instanceof File ? URL.createObjectURL(src) : src
    const key = src instanceof File ? src.path : src

    return (
        <VideoContainer height={height} width={width} key={key} ref={ref} controls={controls} onDurationChange={onDurationChange} onLoadedMetadata={onLoadedMetadata}>
            <source src={formattedSrc} type={type} />
        </VideoContainer>
    )
})

Video.propTypes = {
    controls: PropTypes.bool,
    onDurationChange: PropTypes.func,
    onLoadedMetadata: PropTypes.func,
    src: PropTypes.oneOfType([PropTypes.instanceOf(File), PropTypes.string]),
    type: PropTypes.string,
    height:PropTypes.string,
    width:PropTypes.string
}

Video.defaultProps = {
    controls: true,
    onDurationChange: () => null,
    onLoadedMetadata: () => null,
    src: null,
    type: 'video/*',
}

export default Video
